import { AxiosResponse } from 'axios'
import { IPaginatedEntityGST, IEntityGST, IGenericResponseGST } from 'services/core/genericEntityGST'
import { RequestGST, RequestREAD } from 'services/Instances'

export const LogEmailJobService = () => {
  const path = 'LogEmailJob'
  const getTipos = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/TiposJob`, {
      params: {
        txTipoContexto: 'GST'
      }
    })

  const getWithFilters = async (params: IGetWithFiltersParams): Promise<AxiosResponse<IPaginatedEntityGST<IGetWithFiltersResponse[]>>> =>
    await RequestREAD.get(`${path}/GetWithFilters`, {
      params: params
    })

  return { getTipos, getWithFilters }
}

export const ValidacaoTecnicaServices = () => {
  const getAllCentrosPlanta = async (): Promise<AxiosResponse<IEntityGST<IValidacaoTecnicaGetAllCentrosPlanta>>> =>
    await RequestGST.get('CentroPlanta/PopularGrids')

  const AtualizarFlagValidacao = async (body: IAtualizarFlagValidacao): Promise<AxiosResponse<IGenericResponseGST>> =>
    await RequestGST.patch('CentroPlanta/AtualizarFlagValidacao', body)

  return {
    AtualizarFlagValidacao,
    getAllCentrosPlanta,
  }
}

export interface IAtualizarFlagValidacao {
  comValidacaoUpdate: number[]
  semValidacaoUpdate: number[]
}

export interface ComValidacao {
  idCentroPlanta: number;
  empresaId: number;
  txDescricaoCentroPlanta: string;
  cdCentroCusto: string;
  cdCep: string;
  cdUF: string;
  nuCNAE: string;
  nuCNPJ: string;
  nuTelefone: string;
  txCidade: string;
  txEndereco: string;
  dtUltimaAtualizaçãoSap: Date;
  dtAtualizaçãoSap: Date;
  flNecessitaValidacao: boolean;
  // local
  isChecked?: boolean
}

export interface SemValidacao {
  idCentroPlanta: number;
  empresaId: number;
  txDescricaoCentroPlanta: string;
  cdCentroCusto: string;
  cdCep: string;
  cdUF: string;
  nuCNAE: string;
  nuCNPJ: string;
  nuTelefone: string;
  txCidade: string;
  txEndereco: string;
  dtUltimaAtualizaçãoSap: Date;
  dtAtualizaçãoSap: Date;
  flNecessitaValidacao: boolean;
  // local
  isChecked?: boolean
}

export interface IValidacaoTecnicaGetAllCentrosPlanta {
  comValidacao: ComValidacao[];
  semValidacao: SemValidacao[];
}

export interface IGetWithFiltersParams {
  pageNumber?: number
  pageSize?: number
  NmFornecedor?: string
  DtEnvioInicio?: Date | string
  DtEnvioFim?: Date | string
  NmContraparte?: string
  NmTipoJOB?: string
  txTipoContexto?: string
  cdContrato?: string
}

export interface IGetWithFiltersResponse {
  cdMatriculaContraparte: string
  dtEnvioEmail: string
  idLogEmailJob: 1
  nmContraparte: string
  nmFornecedor: string
  nmTipoJOB: string
  txEmailResponsavel: string
  txCorpoEmail?: string
  cdContrato?: string
}

